import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getPageTitleKey } from '../hooks/usePageTitle';

/**
 * Component to automatically manage page title based on current route
 * Place this component in App.tsx to handle all routes automatically
 */
export const PageTitleManager = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const titleKey = getPageTitleKey(location.pathname);
    const appName = t('appName');
    
    if (titleKey) {
      const translatedTitle = t(titleKey);
      document.title = `${translatedTitle} | ${appName}`;
    } else {
      // Default title for unknown routes
      document.title = appName;
    }
  }, [location.pathname, t, i18n.language]);

  return null; // This component doesn't render anything
};
